import React from 'react';
import Hero from './components/academic-gallery/Hero';
import Main from './components/academic-gallery/Main';


const AcademicGallery = () => {
  return (
    <div>
      <Hero />
      <Main/>
    </div>
  )
}

export default AcademicGallery;